import { __makeTemplateObject } from "tslib";
import { motion } from "framer-motion";
import styled from "styled-components";
export var DropdownContainer = styled(motion.div)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  position: absolute;\n  top: ", "px;\n  right: ", "px;\n  min-width: ", "px;\n  max-height: ", "px;\n  gap: 10px;\n  border-radius: ", ";\n  background: white;\n  box-shadow: ", ";\n  padding: ", ";\n  overflow-y: auto;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  position: absolute;\n  top: ", "px;\n  right: ", "px;\n  min-width: ", "px;\n  max-height: ", "px;\n  gap: 10px;\n  border-radius: ", ";\n  background: white;\n  box-shadow: ", ";\n  padding: ", ";\n  overflow-y: auto;\n"])), function (_a) {
    var top = _a.top;
    return top;
}, function (_a) {
    var right = _a.right;
    return right;
}, function (_a) {
    var minWidth = _a.minWidth;
    return minWidth;
}, function (_a) {
    var maxHeight = _a.maxHeight;
    return maxHeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.radius.m;
}, function (_a) {
    var theme = _a.theme;
    return theme.shadows.default;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.xs;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map